import React, { FC } from 'react';
import { Search as SearchIcon } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';

import {
  SearchSuggestions,
  Suggestion,
} from '../SearchSuggestions/SearchSuggestions';

import s from './Search.scss';
import cs from 'classnames';
import { isCategorySlug } from '../../config';

interface SearchProps {
  withSuggestions?: boolean;
  className?: string;
  value?: string;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  autoFocus?: boolean;
  onCloseClick?: () => void;
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSuggestionClick?: (value: Suggestion) => void;
}

export const Search: FC<SearchProps> = ({
  withSuggestions,
  className,
  onChange,
  value,
  autoFocus,
  onBlur,
  onFocus,
  onCloseClick,
  onKeyUp,
  onSuggestionClick,
}) => {
  const { t } = useTranslation();
  const inputRef = React.useRef<HTMLInputElement>(null);

  const onCloseButtonClick = () => {
    onCloseClick?.();
    inputRef.current?.focus();
  };

  return (
    <div className={s.container}>
      <div className={cs(s.inputContainer, className)}>
        <div className={s.searchIcon}>
          <SearchIcon className={s.searchIcon} />
        </div>
        <input
          value={value}
          ref={inputRef}
          onChange={(e) => onChange?.(e.target.value)}
          className={s.input}
          onKeyUp={onKeyUp}
          autoFocus={autoFocus}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder={t('app.main.header.input.placeholder')}
        />
        {value && (
          <div onClick={onCloseButtonClick} className={s.clearButton}>
            <div className={s.crossIcon} />
          </div>
        )}
      </div>
      {withSuggestions && (
        <SearchSuggestions
          onSuggestionClick={(suggestion) => {
            onSuggestionClick?.(suggestion);
            if (!isCategorySlug(suggestion.slug)) {
              inputRef.current?.focus();
            }
          }}
        />
      )}
    </div>
  );
};
